module.exports = __webpack_public_path__ + "static/media/left-bridge.d5d883df.svg";